export default "__VITE_ASSET__333ea813__"